var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "master-filter search-filter"
  }, [_c('label', {
    staticClass: "search-label"
  }, [_c('span', {
    staticClass: "dropdown-title"
  }, [_vm._v("Klient")]), _c('span', {
    staticClass: "search-field"
  }, [_c('svg', {
    staticClass: "search-icon",
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "6.5",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 16L21 21",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    staticClass: "search-field-input",
    attrs: {
      "type": "search",
      "autocomplete": "off",
      "placeholder": "Meno alebo telefón",
      "aria-label": "Hľadať klienta podľa mena alebo telefónu"
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.query = $event.target.value;
      }, _vm.scheduleFilter],
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.emitFilter.apply(null, arguments);
      }
    }
  }), _vm.query ? _c('button', {
    staticClass: "search-clear",
    attrs: {
      "type": "button",
      "aria-label": "Vymazať vyhľadávanie"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" × ")]) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }